var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options !== null && _vm.options.attrs !== null
    ? _c(
        "el-select",
        {
          attrs: {
            size: _vm.size,
            multiple: _vm.options.attrs.multiple,
            placeholder: _vm.options.attrs.placeholder,
            "popper-append-to-body": _vm.inScreen,
          },
          on: { change: _vm.changeValue },
          model: {
            value: _vm.values,
            callback: function ($$v) {
              _vm.values = $$v
            },
            expression: "values",
          },
        },
        _vm._l(_vm.options.attrs.data, function (item) {
          return _c("el-option", {
            key: item[_vm.options.attrs.key],
            attrs: {
              label: item[_vm.options.attrs.label],
              value: item[_vm.options.attrs.value],
            },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }